declare var require: any;
const faye = require('faye');

const base = 'https://devoptaapi.realfantasyteams.com';
const fayeClient = new faye.Client(`${base}/faye`);
fayeClient.setHeader('Access-Control-Allow-Origin', '*');

export default fayeClient;
